/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import { Lead } from 'types/entities/Lead'
import EditCompanyModalLeadItem from './EditCompanyModalLeadItem'

interface EditCompanyModalLeadListProps {
    leads: Lead[]
    onClick: (lead: Lead) => void
}

const EditCompanyModalLeadList = (props: EditCompanyModalLeadListProps) => {
    if (!props.leads.length) {
        return null
    }

    return (
        <>
            {props.leads.map((lead) => (
                <EditCompanyModalLeadItem
                    key={`${lead.id}`}
                    lead={lead}
                    onClick={props.onClick}
                />
            ))}
        </>
    )
}

export default EditCompanyModalLeadList
